import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function NavMenu() {
  const [openMantenedor, setOpenMantenedor] = useState(false);

  const toggleMantenedor = () => setOpenMantenedor(prev => !prev);

  return (
    <aside className="w-56 bg-gray-900 text-white min-h-screen p-4">
      {/* Logo */}
      <div className="mb-6 text-xl font-bold">Dimalink :)</div>
      
      <nav className="flex flex-col">
        {/* Inicio */}
        <NavLink
          to="/home"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded mb-1 transition ${
              isActive ? 'bg-gray-700' : 'hover:bg-gray-800'
            }`
          }
        >
          <span>🏠</span>
          <span>Inicio</span>
        </NavLink>

        {/* Configuración */}
        <NavLink
          to="/configuracion"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded mb-1 transition ${
              isActive ? 'bg-gray-700' : 'hover:bg-gray-800'
            }`
          }
        >
          <span>⚙️</span>
          <span>Configuración</span>
        </NavLink>

        {/* Mantenedor con submenú desplegable */}
        <div>
          <button
            onClick={toggleMantenedor}
            className={`w-full text-left flex items-center justify-between gap-2 px-3 py-2 rounded mb-1 transition ${
              openMantenedor ? 'bg-gray-700' : 'hover:bg-gray-800'
            }`}
          >
            <div className="flex items-center gap-2">
              <span>🛠️</span>
              <span>Mantenedor</span>
            </div>
            <span className="text-sm">{openMantenedor ? '▾' : '▸'}</span>
          </button>

          {openMantenedor && (
            <div className="ml-6 flex flex-col">
              {/* Equipos (Módulos) */}
              <NavLink
                to="/mantenedormodulos"
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded mb-1 transition ${
                    isActive ? 'bg-gray-700' : 'hover:bg-gray-800'
                  }`
                }
              >
                <span>💻</span>
                <span>Equipos</span>
              </NavLink>

              {/* Sectores */}
              <NavLink
                to="/mantenedorsectores"
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded mb-1 transition ${
                    isActive ? 'bg-gray-700' : 'hover:bg-gray-800'
                  }`
                }
              >
                <span>📊</span>
                <span>Sectores</span>
              </NavLink>

              {/* Válvulas */}
              <NavLink
                to="/mantenedorvalvulas"
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded mb-1 transition ${
                    isActive ? 'bg-gray-700' : 'hover:bg-gray-800'
                  }`
                }
              >
                <span>🔧</span>
                <span>Válvulas</span>
              </NavLink>
            </div>
          )}
        </div>
      </nav>
    </aside>
  );
}
